import React, { useContext, useState } from "react";
import { Aside, CommandBarButton } from "sprint-common-web";

import { IntegratorsDataContext } from "../../../../../common/data/lookup-data-providers/IntegratorsDataProvider";
import { SystemsDataContext } from "../../../../../orders/common/data-providers/SystemsDataProvider";
import { AddSystemPlatformForm } from "../../forms/add/AddSystemPlatformForm";

export const AddSystemPlatformButton: React.FC = () => {
    const { isLoading: isIntegratorsLoading } = useContext(IntegratorsDataContext);
    const { isLoading: isSystemsLoading } = useContext(SystemsDataContext);

    const isLoading = isIntegratorsLoading || isSystemsLoading;

    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <CommandBarButton onClick={openSidebar} text="Add" icon="Add" />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Add" onDismiss={closeSidebar} isLoading={isLoading}>
                <AddSystemPlatformForm onCancel={closeSidebar} onSubmit={closeSidebar} />
            </Aside>
        </>
    );
};
